import * as React from "react";
import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  FormControl,
} from "@mui/material";

type ShowBooleanProps = {
  label: string;
  value: boolean;
  helperText?: string;
  compact?: boolean;
  hidden?: boolean;
};

export const ShowBoolean: React.FC<ShowBooleanProps> = ({
  label,
  value,
  helperText = "",
  compact = false,
  hidden = false,
}) => {
  if (hidden) return null;
  const sx = compact ? { m: 0, p: 0 } : { ml: 1 };
  return (
    <FormControl>
      <FormControlLabel
        sx={{ ...sx }}
        control={<Checkbox size={"small"} checked={value} />}
        label={label}
      />
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};
